// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const walking_wake: PokeData = {
  "id": 1009,
  "name": "walking-wake",
  "height": 35,
  "weight": 2800,
  "base_experience": 295,
  "types": [
    PokeType.WATER,
    PokeType.DRAGON
  ],
  "api_moves": [
    "leer",
    "bite",
    "roar",
    "flamethrower",
    "hydro-pump",
    "outrage",
    "dragon-breath",
    "twister",
    "water-pulse",
    "dragon-pulse",
    "dragon-rush",
    "aqua-jet",
    "noble-roar",
    "breaking-swipe",
    "hydro-steam"
  ],
  "moves": [
    "leer",
    "bite",
    "flamethrower",
    "hydro-pump",
    "outrage",
    "dragon-breath",
    "dragon-pulse",
    "dragon-rush",
    "aqua-jet",
    "life-dew",
    "bubble-beam",
    "great-roar",
    "dragon-dance"
  ],
  "evolution_chain": {
    "id": 537,
    "item": null,
    "species": [
      {
        "name": "walking-wake",
        "order": 1011,
        "types": [
          PokeType.WATER,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 114,
    "speed": 133,
    "ability_power": 153
  },
  "stat_changes": [],
  "catch_rate": 5,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
